import React, { useState } from "react";
import { useParams } from "react-router-dom";

import { CommentEntityType, CommentThreadType } from "../api/comments";
import { CaseHeaderInfoContainer } from "./caseinfo/components/CaseHeaderInfoContainer";
import CommentMainPage from "./comments/components/CommentMainPage";
import AIInsightsPanel from "./aiInsights/components/AIInsightsPanel";
import { CaseStageComponent } from "./caseStages/components/CaseStageComponent";

const CaseInfoPage: React.FC = () => {
  const { id: caseId } = useParams<{ id: string }>();
  const [isInsightsOpen, setIsInsightsOpen] = useState(false);

  const renderContent = () => {
    if (!caseId) return null;

    return (
      <div className="p-4 md:p-6 lg:p-8 flex flex-col gap-6">
        <CaseStageComponent/>
        <CaseHeaderInfoContainer
          caseId={caseId}
          className="mb-6"
          onClickAIInsights={() => setIsInsightsOpen(true)}
        />

        <CommentMainPage
          caseId={caseId}
          entityId={caseId}
          entityType={CommentEntityType.CASE}
          threadType={CommentThreadType.CASE_OVERVIEW}
          className="mx-0"
        />
      </div>
    );
  };

  return (
    <div className="flex-1 overflow-auto bg-[#F3F4F6]">
      {isInsightsOpen && (
        <AIInsightsPanel onClose={() => setIsInsightsOpen(false)} />
      )}
      {renderContent()}
    </div>
  );
};

export default CaseInfoPage;
